/**
 * Enum & konstanta bersama.
 * Sumber kebenaran: pipeline baru — Prompt Generator Only.
 *
 * PENTING: file ini dipakai oleh apps/api (Worker) DAN apps/web (SPA),
 * jadi TIDAK BOLEH ada import Node-native (fs, path, dsb) di sini.
 */

export const ASSET_KIND = ['image', 'reference'] as const;
export type AssetKind = (typeof ASSET_KIND)[number];

export const ASPECT_RATIO = ['9:16', '1:1', '16:9'] as const;
export type AspectRatio = (typeof ASPECT_RATIO)[number];

export const STORYBOARD_STATUS = ['draft', 'awaiting_approval', 'approved'] as const;
export type StoryboardStatus = (typeof STORYBOARD_STATUS)[number];

export const SCENE_STATUS = ['pending', 'generating', 'done', 'failed'] as const;
export type SceneStatus = (typeof SCENE_STATUS)[number];

/**
 * State machine Agent Orchestrator — pipeline Prompt Generator.
 *
 * PLANNING → CONCEPT_GENERATION → STORYBOARD_DRAFT → HUMAN_REVIEW
 *   → PROMPT_EXPORT → COMPLETED
 *
 * PROMPT_EXPORT: LLM memformat ulang scenePrompt tiap scene menjadi
 * prompt siap-pakai untuk Midjourney, Sora, Kling, Runway, dan generic.
 * Tidak ada generate gambar/video/suara — output teks saja.
 */
export const GENERATION_STAGE = [
  'PLANNING',
  'CONCEPT_GENERATION',
  'STORYBOARD_DRAFT',
  'HUMAN_REVIEW',
  'PROMPT_EXPORT',   // LLM format prompts per scene per tool (Midjourney/Sora/Kling/Runway)
  'COMPLETED',
] as const;
export type GenerationStage = (typeof GENERATION_STAGE)[number];

export const CURRENCY = ['IDR', 'USD'] as const;
export type Currency = (typeof CURRENCY)[number];

/**
 * Tipe konten pipeline.
 *   'ad'    — pipeline iklan produk (existing default)
 *   'drama' — pipeline drama sinematik (campuran narasi + dialogue, output screenplay)
 */
export const CONTENT_TYPE = ['ad', 'drama'] as const;
export type ContentType = (typeof CONTENT_TYPE)[number];

/**
 * `generation_jobs.currentStep` — status human-facing untuk UI polling.
 * BERBEDA dari `GenerationStage` (internal Queue engine) — keduanya dipisah
 * supaya vocabulary UI bisa berubah tanpa ubah mesin pipeline.
 *
 * 'exporting_prompts': job sedang menjalankan PROMPT_EXPORT (LLM formatting).
 */
export const JOB_STATUS = [
  'queued',
  'planning',
  'concepts_ready',       // pause setelah CONCEPT_GENERATION — user pilih konsep
  'storyboard_ready',
  'awaiting_approval',    // pause setelah STORYBOARD_DRAFT — user approve storyboard
  'exporting_prompts',    // PROMPT_EXPORT sedang berjalan
  'completed',
  'failed',
] as const;
export type JobStatus = (typeof JOB_STATUS)[number];
